<template>
  <KeypadSetting
    :tag="tag"
    :popoverTitle="'Accumulated fan time'"
    :showingPopover="showingPopover"
    :selectedCells="selectedCells"
    :getSubmitValues="getSubmitValues"
    @update:showingPopover="value => $emit('update:showingPopover', value)"
    @keypress="char => onKeyPressed(char)"
    @submit="onSubmit()"
    @erase="onErase()"
  >
    <div>
      {{ timeString }}
    </div>
    <template #InputBox>
      <div class="AccFanTimeStatus-inputBox p-inputtext">
        <span :class="{ selected: keypadSelection == 'hours'}" @click="select('hours')">
          {{ pad(hours, 1) }}h
        </span>
        <span :class="{ selected: keypadSelection == 'minutes'}" @click="select('minutes')">
          {{ pad(minutes, 2) }}m
        </span>
        <span :class="{ selected: keypadSelection == 'seconds'}" @click="select('seconds')">
          {{ pad(seconds, 2) }}s
        </span>
      </div>
    </template>
    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>
  </KeypadSetting>
</template>

<script>
import KeypadSetting from "./KeypadSetting.vue";

export default {
  components: { KeypadSetting },
  props: [
    "tag",
    "committed",
    "selectedCells",
    "showingPopover"
  ],
  data() {
    return {
      hours: null,
      minutes: null,
      seconds: null,
      modified: false,
      keypadSelection: "hours",
      clearSelectionOnKeypress: true
    }
  },
  computed: {
    timeString() {
      let { hours, minutes, seconds } = getTotalTimeHMS(this.tag.value);
      if (hours > 0)
        return `${hours}h ${minutes}m ${seconds}s`;
      else
        return `${minutes}m ${seconds}s`;
    }
  },
  watch: {
    showingPopover() {
      let { hours, minutes, seconds } = getTotalTimeHMS(this.tag.value);
      this.hours = hours; 
      this.minutes = minutes;
      this.seconds = seconds;
      this.keypadSelection = "hours";
      this.clearSelectionOnKeypress = true;
    },
    keypadSelection() {
      this.clearSelectionOnKeypress = true;
    }
  },
  methods: {
    pad(value, padLen) {
      return value.toString().padStart(padLen, '0');
    },
    select(selection) {
      this.keypadSelection = selection;
      this.clearSelectionOnKeypress = true;
    },
    onErase() {
      this[this.keypadSelection] = 0;
    },
    onKeyPressed(char) {
      let newValue = null;
      if (this.clearSelectionOnKeypress) {
        newValue = parseInt(char);
      }
      else {
        let oldValue = this[this.keypadSelection].toString();
        newValue = parseInt(oldValue.toString() + char);
        if (this.keypadSelection != "hours" && newValue >= 60) 
          newValue = parseInt(char);
      }
      this[this.keypadSelection] = newValue; //.toString().padStart(2, '0');
      this.clearSelectionOnKeypress = false;
      this.modified = true;
    },
    getSubmitValues(cell, value) {
      return [{
        handle: cell.componentArgs.tag.handle,
        value: this.hours * 3600 + this.minutes * 60 + this.seconds
      }];
    }
  }
}

function getTotalTimeHMS(totalSeconds) {
  let hours = Math.floor(totalSeconds / 3600);
  let minutes = parseInt(totalSeconds % 3600 / 60);
  let seconds = totalSeconds % 60;
  return { hours, minutes, seconds };
}

</script>

<style>
.AccFanTimeStatus-inputBox {
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  font-size: larger;
  font-family: Reddit Mono;
}
.AccFanTimeStatus-inputBox span {
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 3px;
}
.AccFanTimeStatus-inputBox span.selected {
  color: white;
  background: dodgerblue;
}
</style>